import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../../AccountListView.js";

export class ZIDXAccountErrorLogs implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountErrorLogsContainer";
    }


    render() {

        let listView=new ZIDXAccountListView(this.zidx);
        listView.render();
    }
}